import { MenuItem, Select, type SelectChangeEvent } from '@mui/material';
import { useGridApiContext, type GridRenderEditCellParams } from '@mui/x-data-grid';
import type { ComboBoxDataItem } from '../../utils/transform-to-options';

type ComboBoxCellProps = GridRenderEditCellParams & { options: ComboBoxDataItem[] };

const ComboBoxCell = ({ id, value, field, options }: ComboBoxCellProps) => {
  const api = useGridApiContext();

  const handleChange = (event: SelectChangeEvent<any>) => {
    const newValue = event.target.value;
    api.current.setEditCellValue({ id, field, value: newValue }, event);
  };

  return (
    <Select value={value} onChange={handleChange} fullWidth>
      {options.map((option) => (
        <MenuItem
          value={option.value}
          key={`item-${option.value}`}
          disabled={option.disabled === true}
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default ComboBoxCell;
